import React from 'react';

const AddBaner = () => (
  <div className="min-h-screen bg-slate-100 text-slate-900">
    <div className="mx-auto max-w-4xl p-8">
      <div className="rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm">
        <h1 className="text-3xl font-semibold text-slate-900">Add Banner</h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">This page is currently available, and will display the banner editor once it is implemented.</p>
      </div>
    </div>
  </div>
);

export default AddBaner;
